import { Text, View } from "react-native";
import CustomCourseWorkContentMenu from "../../../components/navigation/CustomCourseWorkContentMenu/CustomCourseWorkContentMenu";
import React from "react";
import { useActiveCourse } from "../../../contexts/ActiveCourseContext";

const CustomCourseworkMenuContainer = () => {
  const { modalState, courseData, courseLoading, handleSelectModule, handleSelectActivity, handleOpenAddModule } =
    useActiveCourse();

  const selectedCourse = courseData?.getCourseById?.data[0];

  if (courseLoading)
    return (
      <View>
        <Text>Loading...</Text>
      </View>
    );

  return (
    <>
      {selectedCourse ? (
        <CustomCourseWorkContentMenu
          data={selectedCourse}
          onSelectModule={handleSelectModule}
          onSelectActivity={handleSelectActivity}
          selectedModule={modalState.activeModule}
          selectedActivity={modalState.activeActivity}
          onAddModule={handleOpenAddModule}
        />
      ) : (
        <View>
          <Text>No courses available</Text>
        </View>
      )}
    </>
  );
};

export default CustomCourseworkMenuContainer;
